const rankItems = [
  { rank: 1, title: '流浪地球3', meta: '科幻 · 9.2分', tag: '热播中', tagColor: 'bg-accent-500' },
  { rank: 2, title: '封神第二部', meta: '奇幻 · 8.8分', tag: '新上线', tagColor: 'bg-primary-500' },
  { rank: 3, title: '沙丘3', meta: '科幻 · 9.0分', tag: '推荐', tagColor: 'bg-secondary-500' },
  { rank: 4, title: '奥本海默', meta: '传记 · 8.9分', tag: '经典', tagColor: 'bg-background-500' },
  { rank: 5, title: '孤注一掷', meta: '犯罪 · 8.5分', tag: '热门', tagColor: 'bg-primary-500' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">热门排行</h2>
            <p className="text-foreground-500 text-sm mt-1">全网观众都在看的影片</p>
          </div>
          <span className="text-foreground-500 text-xs">实时更新</span>
        </div>
        <div className="space-y-3">
          {rankItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-500/30 transition-colors cursor-pointer group"
            >
              <span className={`font-heading text-2xl md:text-3xl font-bold w-10 text-center flex-shrink-0 ${
                item.rank <= 3 ? 'text-primary-400' : 'text-foreground-600'
              }`}>
                {item.rank.toString().padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm mt-0.5">{item.meta}</p>
              </div>
              <span className={`px-3 py-1 rounded-full text-xs font-medium text-background-950 ${item.tagColor} whitespace-nowrap`}>
                {item.tag}
              </span>
              <div className="hidden sm:flex items-center gap-2 text-foreground-500 text-xs">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> 128万</span>
                <span className="flex items-center gap-1"><i className="ri-thumb-up-line"></i> 9.6万</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}